<div class="bg pause"
     [class.filled]="paused$ | async">
</div>
